import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import tableConfig, { data } from './config';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import Ratings from '../common/Rating';
import Type from '../common/Types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ReviewsAndRatings from '../ReviewsAndRatings';
import Sales from '../Sales';
import { Button, Upload } from 'antd';
import { useParams } from 'react-router-dom';
import Loader from '../common/Loader';
import { getSellerDetailsById } from '../../actions/chefsandrestaurants';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router-dom';
import OrdersByChefTable from '../OrdersByChefTable';
import './ChefAndRestaurantProfile.css';
import PaymentByChef from '../PaymentByChef';
import Table from '../common/SettlementsTable/Table';
import { settlementTransactionTableConfig } from '../Settlements/config';
import { DatePicker, Space } from 'antd';
import {
  AddRemoveSellerDiscountModal,
  AddUpdateDiscountModal
} from './AddRemoveSellerDiscountModal';
import { addRemoveSellerDiscountHook } from '../../hooks';
import Grid from '@material-ui/core/Grid';
import { DeleteSellerDiscountModal } from './DeleteSellerDiscountModal';
import { SOCKET_URL_ENDPOINT } from '../../constants';
import clsx from 'clsx';
import * as Icons from '../Icons';
const { RangePicker } = DatePicker;

const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#43a047'
    },
    marginBottom: '16px'
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />);

const ChefAndRestaurantProfile = props => {
  const {
    showAddSellerDiscountModal,
    toggleAddDiscountModal,
    formData,
    sellerDiscountData,
    handleSwitchChange,
    handleSelectChange,
    handleDateChange,
    handleSellerDiscountSubmit,
    toggleDeleteDiscountModal,
    showDeleteSellerDiscountModal,
    handleDeleteSellerDiscount,

    sellerdet,
    sellercuisins,
    deliveryopt,
    foodSellerAvailableTimes,
    foodSellerAdditionalDiscounts,
    statistics,
    msg,
    msgstatus,
    uploadFileData,
    loading,
    fileRef,
    downloadFile,
    handleFileUpload,
    handleFileSubmit
  } = addRemoveSellerDiscountHook();

  const classes = props.classes;
  const history = useHistory();
  let config = tableConfig(props);
  const historyConfig = settlementTransactionTableConfig();

  const params = useParams();

  let sellerId = params.id;
  let sellerType = params.name;

  const [selectedDates, setSelectedDates] = useState([]);
  const disabledDate = current => {
    return current && current > moment().endOf('day');
  };

  //console.log('params',history.location.pathname);
  const onView = () => {
    //console.log("View");
  };
  const onDelete = () => {
    //console.log("Delete")
  };

  const [state, setState] = useState({
    users: true,
    chefs: false,
    restaurants: false
  });

  const handleChange = event => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  useEffect(() => {}, []);

  return (
    <div style={{ width: '100%' }}>
      {/* <Box display="flex" p={1} className="mb-3" justifyContent="flex-end">
        <Button onClick={() => { history.goBack(); }} size="small" label="Back"></Button>
      </Box> */}
      <React.Fragment>
        {msgstatus !== 200 && (
          <div className={classes.errorwrap}>
            <h1>{msg}</h1>
          </div>
        )}
        {msgstatus !== 200 && sellerdet.length === 0 && <Loader />}
        <div className={classes.wrap}>
          <div className={classes.section1}></div>
          <div className={classes.section2}>
            {sellerdet != '' && (
              <Card className={classes.root}>
                <CardContent>
                  <div className={classes.cardContent}>
                    <Avatar
                      alt="Remy Sharp"
                      src={
                        sellerdet.business_dp_url
                          ? sellerdet.business_dp_url
                          : 'data:image/png;base64,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'
                      }
                      className={classes.profile}
                    />
                    <h2 className="d-flex justify-content-center">
                      <strong>
                        {' '}
                        {sellerdet.business_name
                          ? sellerdet.business_name
                          : '-'}{' '}
                      </strong>
                    </h2>
                    <label className="themeColor mt-2 d-flex justify-content-center align-items-center">
                      <strong>
                        {sellerdet.seller_type ? sellerdet.seller_type : '-'}
                      </strong>
                      <div className="mx-2">
                        {sellerdet.type_of_food === 'Both' ? (
                          <span className="flex">
                            <span className="mr-2">
                              <Type color={'green'} />
                            </span>
                            <span className="mr-2">
                              <Type color={'red'} />
                            </span>
                          </span>
                        ) : (
                          <Type
                            color={
                              sellerdet.type_of_food === 'Veg' ? 'green' : 'red'
                            }
                          />
                        )}
                      </div>
                    </label>
                    <div className="flex justify-content-between align-items-center fullWidth">
                      <Ratings
                        rating={sellerdet.rating ? sellerdet.rating : '0'}
                        ratingCount={sellerdet.total_reviews || '0'}
                      />
                    </div>
                  </div>
                  <div className={classes.profileDetails}>
                    <div className="profileDetails-grid">
                      <div>
                        <div className={classes.item1}>
                          <label> Email </label>
                          <label>
                            {' '}
                            <strong>
                              {sellerdet.user && sellerdet.user.email_id
                                ? sellerdet.user.email_id
                                : '-'}
                            </strong>{' '}
                          </label>
                        </div>
                        <div className={classes.item1}>
                          <label> Mobile Number </label>
                          <label>
                            {' '}
                            <strong>
                              {' '}
                              {sellerdet.user && sellerdet.user.mobile_no
                                ? sellerdet.user.mobile_no
                                : '-'}
                            </strong>{' '}
                          </label>
                        </div>
                        <div className={classes.item1}>
                          <label> Delivery Options </label>
                          <div className={classes.users}>
                            {deliveryopt && deliveryopt.length > 0
                              ? deliveryopt.map((deliveryoptData, t) => {
                                  return (
                                    <FormControlLabel
                                      key={deliveryoptData.seller_id}
                                      classes={{
                                        label: classes.checkBoxLabel,
                                        root: classes.labelRoot
                                      }}
                                      control={
                                        <GreenCheckbox
                                          size="small"
                                          checked={state.users}
                                          onChange={handleChange}
                                          name={
                                            deliveryoptData.delivery_option
                                              .option_name
                                          }
                                        />
                                      }
                                      label={
                                        deliveryoptData.delivery_option
                                          .option_name
                                      }
                                    />
                                  );
                                })
                              : '-'}
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className={classes.item1}>
                          <label> Delivery Charges </label>
                          <label>
                            &#8377;{' '}
                            <strong>
                              {sellerdet.delivery_charges
                                ? sellerdet.delivery_charges
                                : '0'}
                            </strong>{' '}
                          </label>
                        </div>

                        <div className={classes.item1}>
                          <label> GST Number </label>
                          <label>
                            <strong>
                              {sellerdet.gstin ? sellerdet.gstin : '-'}
                            </strong>{' '}
                          </label>
                        </div>

                        <div className={classes.item1}>
                          <label> FSSAI Number </label>
                          <label>
                            <strong>
                              {sellerdet.fssai_no ? sellerdet.fssai_no : '-'}
                            </strong>{' '}
                          </label>
                        </div>

                        <div className={classes.item1}>
                          <label> Cuisines </label>
                          <div className={classes.users}>
                            {sellercuisins &&
                              sellercuisins.map((sellercuisin, t) => {
                                const cuisineName =
                                  sellercuisin.cuisine &&
                                  sellercuisin.cuisine.cuisine_name
                                    ? sellercuisin.cuisine.cuisine_name
                                    : '-';
                                return (
                                  <FormControlLabel
                                    key={sellercuisin.cuisine_id}
                                    classes={{
                                      label: classes.checkBoxLabel,
                                      root: classes.labelRoot
                                    }}
                                    control={
                                      <GreenCheckbox
                                        size="small"
                                        checked={state.users}
                                        onChange={handleChange}
                                        name={cuisineName}
                                      />
                                    }
                                    label={cuisineName}
                                  />
                                );
                              })}
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className={classes.item1}>
                          <label> Business Address </label>
                          <label>
                            <strong>
                              {' '}
                              {sellerdet.address_line1
                                ? sellerdet.address_line1
                                : '-'}{' '}
                              {sellerdet.address_line2
                                ? sellerdet.address_line2
                                : ''}
                            </strong>
                            <RoomOutlinedIcon />
                          </label>
                        </div>

                        <div className={classes.item1}>
                          <label> About me </label>
                          <label>
                            {' '}
                            <strong>
                              {sellerdet.about_seller
                                ? sellerdet.about_seller
                                : '-'}
                            </strong>{' '}
                          </label>
                        </div>

                        <div className={classes.item1}>
                          <label> Account Create Date </label>
                          <label>
                            {' '}
                            <strong>
                              {sellerdet.created_date
                                ? sellerdet.created_date
                                : '-'}
                            </strong>{' '}
                          </label>
                        </div>

                        <div className={classes.item1}>
                          <div>Bulk items upload</div>
                          <div style={{ padding: 10 }}>
                            <div>
                              <Button
                                type="noFill"
                                onClick={downloadFile}
                                className="flex"
                              >
                                <img
                                  src={Icons.download}
                                  style={{ width: 18 }}
                                />{' '}
                                Download File
                              </Button>
                            </div>
                            <div className="uploaderClass relative inline-flex">
                              <input
                                type="file"
                                accept=".xlsx"
                                onChange={handleFileUpload}
                                name="file"
                                className="uploaderInput"
                                id="chooseFile"
                                ref={fileRef}
                              />
                              <label
                                htmlFor={'chooseFile'}
                                className="uploaderLabel             overflow-hidden                        labelClass"
                              >
                                {!uploadFileData?.file ? (
                                  <div>+ Upload file</div>
                                ) : (
                                  <img
                                    src={Icons.xlsx}
                                    style={{ width: 55, height: 55 }}
                                  />
                                )}
                              </label>
                            </div>

                            {/* <Upload
                              // beforeUpload={handleUpload}
                              accept=".xlsx"
                              showUploadList={false}
                              maxCount={1}
                              onChange={handleFileUpload}
                              beforeUpload={beforeUploadXlsx}
                            > */}
                            {/* <Button>Upload file</Button>
                            </Upload> */}
                            {uploadFileData?.name && (
                              <p>{uploadFileData?.name}</p>
                            )}

                            <div style={{ marginTop: 20 }}>
                              <Button
                                type="primary"
                                onClick={handleFileSubmit}
                                style={{ marginRight: 10 }}
                                loading={loading}
                              >
                                Submit
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
            {sellerdet != '' && statistics != '' && (
              <div className="mt-5">
                <Card className={classes.root}>
                  <CardContent>
                    <h2>
                      {' '}
                      <strong>Statistics</strong>{' '}
                    </h2>
                    {statistics &&
                      statistics.map((stati, t) => {
                        return (
                          <div
                            className={classes.statistics}
                            key={sellerdet.seller_id}
                          >
                            <div className={classes.item}>
                              <label>
                                {' '}
                                <strong>New Orders</strong>{' '}
                              </label>
                              <label className={classes.value}>
                                {' '}
                                <strong>{stati.newOrders}</strong>{' '}
                              </label>
                            </div>
                            <div className={classes.item}>
                              <label>
                                {' '}
                                <strong>Active Orders</strong>{' '}
                              </label>
                              <label className={classes.value}>
                                {' '}
                                <strong>{stati.activeOrders}</strong>{' '}
                              </label>
                            </div>
                            <div className={classes.item}>
                              <label>
                                {' '}
                                <strong>In Delivery</strong>{' '}
                              </label>
                              <label className={classes.value}>
                                {' '}
                                <strong>{stati.inDeliveryOrders}</strong>{' '}
                              </label>
                            </div>
                            <div className={classes.item}>
                              <label>
                                {' '}
                                <strong>Finished Orders</strong>{' '}
                              </label>
                              <label className={classes.value}>
                                {' '}
                                <strong>{stati.finishedOrders}</strong>{' '}
                              </label>
                            </div>
                            <div className={classes.item}>
                              <label>
                                {' '}
                                <strong>Wallet Balance</strong>{' '}
                              </label>
                              <label className={classes.value}>
                                <strong>
                                  {stati.currency === '&#8377;' ? (
                                    <span>&#8377;</span>
                                  ) : (
                                    <span>&#36;</span>
                                  )}
                                  {stati.wallet ? stati.wallet : '0'}
                                </strong>{' '}
                              </label>
                            </div>
                            <div className={classes.item}>
                              <label>
                                {' '}
                                <strong>Total Earnings</strong>{' '}
                              </label>
                              <label className={classes.value}>
                                {' '}
                                <strong>
                                  {stati.currency === '&#8377;' ? (
                                    <span>&#8377;</span>
                                  ) : (
                                    <span>&#36;</span>
                                  )}
                                  {stati.totalEarnings
                                    ? stati.totalEarnings
                                    : '0'}
                                </strong>{' '}
                              </label>
                            </div>
                            <div className={classes.item}>
                              <label>
                                {' '}
                                <strong>Total Menu Items</strong>{' '}
                              </label>
                              <label className={classes.value}>
                                {' '}
                                <strong>{stati.menuItems}</strong>{' '}
                              </label>
                            </div>
                            <div className={classes.item}>
                              <label>
                                {' '}
                                <strong>Total Buyers</strong>{' '}
                              </label>
                              <label className={classes.value}>
                                {' '}
                                <strong>{stati.buyers}</strong>{' '}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                  </CardContent>
                </Card>
              </div>
            )}

            {(sellerdet && sellerdet.bank_account) ||
            (sellerdet && foodSellerAvailableTimes.length > 0) ? (
              <div className="mt-5">
                <div className={classes.otherDetailsWraper}>
                  {sellerdet && sellerdet.bank_account ? (
                    <Card className={classes.bankDetailsCard}>
                      <CardContent className="mt-2">
                        <div className={classes.bankDetails}>
                          <label className={classes.cardHeading}>
                            Bank Details
                          </label>

                          <div className={classes.item1}>
                            <label> Account Holder Name </label>
                            <label>
                              {' '}
                              <strong>
                                {sellerdet.bank_account.account_holder_name ||
                                  '-'}
                              </strong>{' '}
                            </label>
                          </div>
                          <div className={classes.item1}>
                            <label> Bank Name </label>
                            <label>
                              {' '}
                              <strong>
                                {sellerdet.bank_account.bank_name || '-'}
                              </strong>{' '}
                            </label>
                          </div>
                          <div className={classes.item1}>
                            <label> Account Number </label>
                            <label>
                              {' '}
                              <strong>
                                {sellerdet.bank_account.account_number || '-'}
                              </strong>{' '}
                            </label>
                          </div>
                          <div className={classes.item1}>
                            <label> IFSC Code </label>
                            <label>
                              {' '}
                              <strong>
                                {' '}
                                {sellerdet.bank_account.bank_code || '-'}
                              </strong>{' '}
                            </label>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ) : (
                    ''
                  )}

                  {sellerdet && foodSellerAvailableTimes.length > 0 ? (
                    <Card className={classes.openingHoursCard}>
                      <CardContent className="mt-2">
                        <div className={classes.profileDetails}>
                          <label className={classes.cardHeading}>
                            Opening & Closing Time
                          </label>
                          {foodSellerAvailableTimes.map(
                            (foodSellerAvailableDay, timeIndex) => {
                              return (
                                <div
                                  className={classes.timeDurationsContainer}
                                  key={timeIndex}
                                >
                                  <label className={classes.dayLabel}>
                                    {foodSellerAvailableDay.day_name || '-'} :{' '}
                                  </label>
                                  <span className={classes.timeDurations}>
                                    {foodSellerAvailableDay.food_seller_available_times &&
                                      foodSellerAvailableDay.food_seller_available_times.map(
                                        timeData => (
                                          <span>
                                            <strong>
                                              {moment
                                                .utc(
                                                  timeData.from_time,
                                                  'HH:mm:ss'
                                                )
                                                .local()
                                                .format('hh:mm A') +
                                                ' - ' +
                                                moment
                                                  .utc(
                                                    timeData.to_time,
                                                    'HH:mm:ss'
                                                  )
                                                  .local()
                                                  .format('hh:mm A')}
                                            </strong>
                                          </span>
                                        )
                                      )}
                                  </span>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  ) : (
                    ''
                  )}

                  {sellerdet && foodSellerAvailableTimes.length > 0 ? (
                    <Card className={classes.sellerDiscountsCard}>
                      <CardContent className="mt-2">
                        <div className={classes.profileDetails}>
                          <label className={classes.cardHeading}>
                            Seller Additional Discounts{' '}
                          </label>
                          <div style={{ margin: 10 }}>
                            <Button
                              className={'ml-2'}
                              key="submit"
                              type="primary"
                              // loading={isLoading}
                              onClick={toggleAddDiscountModal}
                            >
                              Add discount
                            </Button>
                          </div>
                          {foodSellerAdditionalDiscounts.length > 0 &&
                            foodSellerAdditionalDiscounts.map(
                              (discount, timeIndex) => {
                                const hasValidDiscount =
                                  discount.discount &&
                                  Object.keys(discount.discount).length > 0;
                                return (
                                  <div
                                    className={classes.timeDurationsContainer}
                                    key={timeIndex}
                                  >
                                    {hasValidDiscount && (
                                      <Grid container spacing={3}>
                                        <Grid item xs={4}>
                                          <h6>
                                            {discount.discount.title || '-'}
                                          </h6>
                                          <p>
                                            {discount.discount.description ||
                                              '-'}
                                          </p>
                                        </Grid>
                                        <Grid item xs={4}>
                                          <h6>
                                            {discount?.delivery_option
                                              ?.option_code || '-'}
                                          </h6>
                                        </Grid>
                                        <Grid item xs={2}>
                                          <h6>
                                            {discount?.discount.discount +
                                              (discount?.discount?.is_percentage
                                                ? '%'
                                                : '')}
                                          </h6>
                                        </Grid>
                                        <Grid item xs={2}>
                                          {' '}
                                          <Button
                                            onClick={() =>
                                              toggleDeleteDiscountModal(
                                                discount
                                              )
                                            }
                                            size="small"
                                            label="Back"
                                          >
                                            Delete
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </div>
                                );
                              }
                            )}
                        </div>
                      </CardContent>
                    </Card>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ) : (
              ''
            )}

            <div className={classes.ordersTableContainer}>
              <OrdersByChefTable sellerId={sellerId} />
              {/* {sellerdet != "" &&
                <Sales />
              } */}
            </div>

            <div
              className={`settlement-table-wrapper transaction-history-table-wrapper`}
            >
              <div className="settlements-date-picker-wrap d-flex justify-content-between align-items-center p-3">
                <h5 className="mb-0">Settlement History</h5>
                <Space direction="vertical" size={12}>
                  <RangePicker
                    disabledDate={disabledDate}
                    value={selectedDates}
                    onChange={event => {
                      setSelectedDates(event);
                    }}
                  />
                </Space>
              </div>
              <Table
                key={'settlement-history'}
                title={'Settlement History'}
                selectedDates={selectedDates || []}
                sellerId={sellerId}
                isTransactionHistory={true}
                tableConfig={historyConfig}
              />
            </div>

            {/* <div className={classes.ordersTableContainer}>
              <PaymentByChef sellerId={sellerId} />
            </div> */}

            {/* <div className="mt-3">
              {sellerId != "" && sellerdet != "" &&
                <ReviewsAndRatings id={sellerId} revfun="sellerId" totalrating={sellerdet.rating} rating={[sellerdet['5_rating'], sellerdet['4_rating'], sellerdet['3_rating'], sellerdet['2_rating'], sellerdet['1_rating']]} />
              }
            </div> */}
          </div>
        </div>

        <AddRemoveSellerDiscountModal
          showAddSellerDiscountModal={showAddSellerDiscountModal}
          formData={formData}
          handleSwitchChange={handleSwitchChange}
          sellerDiscountData={sellerDiscountData}
          handleSelectChange={handleSelectChange}
          handleDateChange={handleDateChange}
          handleSellerDiscountSubmit={handleSellerDiscountSubmit}
          toggleAddDiscountModal={toggleAddDiscountModal}
        />

        <DeleteSellerDiscountModal
          toggleDeleteDiscountModal={toggleDeleteDiscountModal}
          showDeleteSellerDiscountModal={showDeleteSellerDiscountModal}
          handleDeleteSellerDiscount={handleDeleteSellerDiscount}
        />
      </React.Fragment>
    </div>
  );
};

export default ChefAndRestaurantProfile;
